const Endpoint = 'https://www.searchanise.com/getresults';
const ApiKey = '4S7N6n9z4y';

export type SortOrder = 'asc' | 'desc';
type ManualSortBy = `collection_${string}_position`;
export type SortBy = ManualSortBy | 'sales_amount' | 'title' | 'price' | 'discount' | 'created' | 'total_reviews';

export const SEARCH_PAGE_SIZE = 24;

export interface ShopifyCollection {
  'collection_id': string
  title: string
  translations: string
}

export interface Options {
  Title?: string
  Size?: string
  Style?: string
  Color?: string
}

export interface ShopifyVariant {
  'variant_id': string
  sku: string
  barcode: string
  price: string
  'list_price': string
  taxable: string
  options: Options
  available: string
  'search_variant_metafields_data': any[]
  'filter_variant_metafields_data': any[]
  'image_link': string
  'image_alt': string
  'quantity_at_location_16246210642'?: string
  'quantity_at_location_37207769170'?: string
  'quantity_total': string
  link: string
}

export interface ResponseItem {
  'product_id': string
  title: string
  description: string
  link: string
  price: string
  'list_price': string
  quantity: string
  'product_code': string
  'image_link': string
  vendor: string
  discount: string
  'add_to_cart_id': string
  'total_reviews': string
  'reviews_average_score': string
  'shopify_variants': ShopifyVariant[]
  'shopify_images': string[]
  'shopify_images_alt'?: string[]
  tags: string
  'metafield_dcff1fdbb2aa7db452b8f6449b648e91'?: string
  'metafield_3ce6450422d50bef8b775a438dae9cc3'?: string
  'metafield_39644d622a6514670a8bcaddb03517f9'?: string // Featured Image
  'metafield_1cc945a25a5b535db1a56f44b04f20cf'?: string
  'quantity_total': string
  'quantity_at_location_16246210642': string
  'quantity_at_location_37207769170'?: string
}

export interface Bucket {
  value: string
  count: number
}

export interface Facet {
  title: string
  attribute: string
  type: string
  appearance: string
  'more_count': string
  'desktop_view': string
  'show_on_mobile': string
  buckets: Bucket[]
}

export type SearchaniseResponse = {
  totalItems: number
  startIndex: number
  itemsPerPage: number
  currentItemCount: number
  'shopify_collection': ShopifyCollection
  'is_collection_mode': string
  items: ResponseItem[]
  facets: Facet[]
};

export type SearchaniseError = {
  error: string;
};

type SearchaniseQueryParams = {
  collection: string;
  startIndex?: number;
  maxResults?: number;
  sortOrder?: SortOrder;
  sortBy?: SortBy;
} & Record<string, unknown>;

export const fetchProducts = async ({
  collection,
  startIndex = 0,
  maxResults = SEARCH_PAGE_SIZE,
  sortOrder = 'desc',
  sortBy = 'sales_amount',
  ...facetParams
}: SearchaniseQueryParams) => {
  const params = [
    `api_key=${ApiKey}`,
    `sortBy=${sortBy}`,
    `sortOrder=${sortOrder}`,
    `startIndex=${startIndex}`,
    `maxResults=${maxResults}`,
    `collection=${collection}`,
    'output=json',
    'items=true',
    'pages=false',
    'categories=false',
    'suggestions=false',
    'facets=true',
    'facetsShowUnavailableOptions=false',
  ];

  Object.keys(facetParams).forEach((facetKey) => {
    if (/restrictBy\[snize_facet\d+\]/.test(facetKey)) {
      params.push(`${facetKey}=${facetParams[facetKey]}`);
    }
  });

  const res = await fetch(`${Endpoint}?${params.join('&')}`);
  const jsonResponse = await res.json();

  if (jsonResponse.error) {
    return jsonResponse as SearchaniseError;
  }

  return jsonResponse as SearchaniseResponse;
};

export const fetchBestSellers = async () => fetchProducts({
  collection: 'best-selling-plants',
  maxResults: 18,
});
